class salmaWebinars  implements ng.IComponentController {
}

angular.module('animatronApp.wave.salmaWebinars', []).component('salmaWebinars', {
    controller: salmaWebinars,
    templateUrl: require('wave/salma-webinars.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/wave/salmaWebinars.ts